import { render } from "./VideoShow.vue?vue&type=template&id=2288ece6"
const script = {}

import "./VideoShow.vue?vue&type=style&index=0&id=2288ece6&lang=scss"

import exportComponent from "/Users/xiaozhi/Documents/codeWork/Vue/Vue项目/mighty_project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__